import React from "react"
import {
	Flex,
	Icon,
	HeaderLogo,
	HEADER_HEIGHT_S,
} from "@capioweb/ui-components/src"
import { MobilePrimaryMenu } from "./MobilePrimaryMenu"
import { PrimaryMenuProps } from "../types"
import { LocalesContext, UIContext } from "../../../context"
import { SearchPopup } from "./SearchPopup"
import { Button } from "@capioweb/ui-components/src"
import { HeaderContext } from "../context/HeaderContext"
import { headerLogoSvg } from "@capioweb/ui-components/src/components/HeaderLogo/assets"
import { assetBaseUrl, isSessionStorageAvailable } from "../../../utils"
import { LoginPopup } from "./LoginPopup"

const MobileHeader: React.FC<PrimaryMenuProps> = (props) => {
	const { togglePrimaryMobileMenuOpen } = React.useContext(UIContext)
	const {
		showSearchPopup,
		setShowSearchPopup,
		showLoginWindowPopup,
		setShowLoginWindowPopup,
	} = React.useContext(HeaderContext)
	const { translate, translationKeys } = React.useContext(LocalesContext)

	return (
		<Flex
			display={{ l: "none" }}
			w={1}
			py={0}
			style={{ margin: "0 auto" }}
			justifyContent="space-between"
			alignItems="center"
		>
			<a href="/" aria-label="Tillbaka till startsidan">
				<HeaderLogo
					alt="Capio"
					src={assetBaseUrl() + props.mainLogo ?? headerLogoSvg}
				/>
			</a>
			<Flex alignItems="center">
				<Flex w={1} h={HEADER_HEIGHT_S} alignItems="center" columnGap={1}>
					{!props.hideSearch && (
						<Flex position="relative">
							<Flex position="relative">
								<Button
									variant="light-blue"
									onClick={() => {
										setShowSearchPopup(!showSearchPopup)
										setShowLoginWindowPopup(false)
									}}
									size="medium"
								>
									<Flex>
										<Icon color="navy" icon="search" size={2.5} />
									</Flex>
									{translate(translationKeys.search)}
								</Button>
							</Flex>

							{showSearchPopup && (
								<Flex
									position="absolute"
									w="100vw"
									right="-167px"
									top="62px"
									px={3}
									flexDirection="row-reverse"
								>
									<SearchPopup
										label={translate(translationKeys.search)}
										showPopup={setShowSearchPopup}
									/>
								</Flex>
							)}
						</Flex>
					)}
					{!props.hideLoginMenu && (
						<Flex position="relative">
							<Button
								onClick={() => {
									setShowLoginWindowPopup(!showLoginWindowPopup)
									if (isSessionStorageAvailable()) {
										sessionStorage.setItem("hideLoginPopup", "1")
									}
									setShowSearchPopup(false)
								}}
								size="medium"
							>
								{props.isLoggedIn
									? translate(translationKeys.menu)
									: translate(translationKeys.login)}
							</Button>
							{showLoginWindowPopup && (
								<Flex
									position="absolute"
									w="100vw"
									right="-54px"
									top="62px"
									px={3}
									flexDirection="row-reverse"
								>
									<LoginPopup
										loginMenuHeading={props.loginMenuHeading}
										loginMenuPreamble={props.loginMenuPreamble}
										loginItems={props.loginMenuItems}
									/>
								</Flex>
							)}
						</Flex>
					)}
					<button onClick={togglePrimaryMobileMenuOpen}>
						<Icon icon="menu" size={4.75} mt={-0.5} mr={-1} />
					</button>
					<MobilePrimaryMenu menu={props.menu} />
				</Flex>
			</Flex>
		</Flex>
	)
}

export { MobileHeader }
